import { useAtom } from 'jotai';
import { productionScheduleRefetchAtom } from './ProductionScheduleRefetchAtom';

export const useConfigProductionScheduleRefetchNeeded = () => {
    return useAtom(productionScheduleRefetchAtom);
};
